module.exports = new __parcel__URL__("demo.ba9c5950.svg").toString();